
import { AdvertiseDto } from "./AdvertiseDto";
import { MachineDto } from "./MachineDto";
import { PromotionDto } from "./PromotionDto";
import { ResPromotionGiftVoucherDto } from "./ResPromotionGiftVoucherDto";
import { VMProductInfoDto } from "./VMProductInfoDto";

/**
 * Cart item object
 */
export default class CartItemDto {
  product?: VMProductInfoDto;
  vendingInfo?: MachineDto;
  advertiseList?: Array<AdvertiseDto>;
  promotionCombo?: PromotionDto;
  promotionGiftVoucher?: ResPromotionGiftVoucherDto;
  qtyBuy?: number;
  lstPosition?: Array<any>;
  constructor(product: VMProductInfoDto, vendingInfo: MachineDto, advertiseList: Array<AdvertiseDto>, promotionCombo: PromotionDto, promotionGiftVoucher: ResPromotionGiftVoucherDto, qtyBuy: number, lstPosition: Array<any>) {
    this.product = product;
    this.vendingInfo = vendingInfo;
    this.advertiseList = advertiseList;
    this.promotionCombo = promotionCombo;
    this.promotionGiftVoucher = promotionGiftVoucher;
    this.qtyBuy = qtyBuy;
    this.lstPosition = lstPosition;
  }
}
